import * as browserCompatibleSelectedOptionsData from '../../consts/analytics/browserCompatibleSelectedOptionsData';
import analyticsService from '../../services/analyticsService';
import backendService from '../../services/app/backendService';
import authDataStoreService from '../../services/auth/authDataStoreService';
import authService from '../../services/auth/authService';
import * as gigyaService from '../../services/gigya/gigyaService';
import iccMarketService from '../../services/icc/iccMarketService';
import marketConfigService from '../../services/marketConfigService';
import marketTypeService from '../../services/marketTypeService';
import appRouterService from '../../services/route/appRouterService';
import userDeviceService from '../../services/user/userDeviceService';
import helpers from '../../utils/helpers';
import {getBrowserCompatibilityPageData} from './browserCompatibilityData';

const BROWSER_NOT_COMPATIBLE_KEY = 0;
const BROWSER_COMPATIBLE_KEY = 1;

const getBrowserCompatibleButtonData = () => {
    const availableContent = getContentAvailability();

    return getBrowserCompatibilityPageData(availableContent, BROWSER_COMPATIBLE_KEY);
};

const getBrowserNotCompatibleButtonData = () => {
    const availableContent = getContentAvailability();

    return getBrowserCompatibilityPageData(availableContent, BROWSER_NOT_COMPATIBLE_KEY);
};

const getContentAvailability = () => {
    const isAppleTouchDevice = userDeviceService.isAppleTouchDevice();
    const isMobileAndroidDevice = userDeviceService.isMobileAndroidDevice();
    const isMobileIOSDevice = userDeviceService.isMobileIOSDevice();
    const isTabletIOSDevice = userDeviceService.isTabletIOSDevice();
    const isDesktopMacOSDevice = userDeviceService.isDesktopMac();
    const isWindowsContent = userDeviceService.isDesktopWindows();
    const isTouchSupported = userDeviceService.isTouchSupported();

    const isAndroidContent = isMobileAndroidDevice;
    const isIOSContent = isMobileIOSDevice || isTabletIOSDevice || isAppleTouchDevice;
    const isMacOSContent = isDesktopMacOSDevice && !isTouchSupported;

    return {isAndroidContent, isIOSContent, isMacOSContent, isWindowsContent};
};

const forwardAfterBrowserVerificationPage = async ({onShowMarketLogin} = {}) => {
    try {
        const isDCE2 = marketTypeService.isDCE2();
        const isUamBackend = backendService.isUamBackend();
        const isMarketDefined = marketTypeService.isMarketDefined();

        analyticsService.pushBrowserCompatibleEvent(browserCompatibleSelectedOptionsData.WEB_APP, true);

        const spiceToken = authDataStoreService.getSpiceToken();
        const gigyaToken = gigyaService.getGigyaToken();

        if (spiceToken || gigyaToken) {
            if (!isUamBackend) {
                appRouterService.forwardToMyDevicesPage();
                return;
            }

            await iccMarketService.getConsumerAggregatedSettings();

            const isTNCEnabled = marketConfigService.isTNCEnabled();

            if (isTNCEnabled) {
                appRouterService.forwardToTNCTermsOfUsePage();
            } else {
                appRouterService.forwardToMyDevicesPage();
            }
        } else {
            if (process.env.REACT_APP_IS_BUILD_REF === 'true') {
                const isICCJourneyScreensEnabled = marketConfigService.isIccJourneyScreensEnabled();

                if (isDCE2) {
                    if (gigyaToken) {
                        appRouterService.forwardToMyDevicesPage();
                    } else {
                        helpers.runFunction(onShowMarketLogin);
                        authService.showMarketLogin();
                    }
                    return;
                }

                if (isMarketDefined && isICCJourneyScreensEnabled) {
                    helpers.runFunction(onShowMarketLogin);
                    authService.showMarketLogin();
                    return;
                }

                appRouterService.forwardToMyDevicesPage();
            } else {
                appRouterService.forwardToAgeGatePage();
            }
        }
    } catch (e) {
        //error page already should be shown
    }
};

export default {
    getBrowserCompatibleButtonData,
    getBrowserNotCompatibleButtonData,
    forwardAfterBrowserVerificationPage,
};
